<template>
  <div class="privacy-policy">
    <h1>{{$t('privacy')}}</h1><br/>
    <h3>{{$t('privacy01')}}</h3><br/>
    <b>{{$t('privacy02')}}</b><br />
    <p>{{$t('privacy03')}}</p>
    <p>{{$t('privacy04')}}</p>
    <br/>
    <b>{{$t('privacy05')}}</b><br />
    <p>{{$t('privacy06')}}</p>
    <br/>
    <b>{{$t('privacy07')}}</b><br />
    <p>{{$t('privacy08')}}</p>
    <p>{{$t('privacy09')}}</p>
    <p>{{$t('privacy10')}}</p>
    <p>{{$t('privacy11')}}</p>
    <p>{{$t('privacy12')}}</p>
    <br/>
    <b>{{$t('privacy13')}}</b><br />
    <p>{{$t('privacy14')}}</p>
    <p>{{$t('privacy15')}}</p>
    <br/>
    <b>{{$t('privacy16')}}</b><br />
    <b>{{$t('privacy17')}}</b><br />
    <p>{{$t('privacy18')}}</p>
    <ul>
      <li>{{$t('privacy19')}}</li>
      <li>{{$t('privacy20')}}</li>
      <li>{{$t('privacy21')}}</li>
      <li>{{$t('privacy22')}}</li>
      <li>{{$t('privacy23')}}</li>
      <li>{{$t('privacy24')}}</li>
    </ul>
    <p>{{$t('privacy25')}}</p>
    <p>{{$t('privacy26')}}</p>
    <p>{{$t('privacy27')}}</p>
    <p>{{$t('privacy28')}}</p>
    <br/>
    <b>{{$t('privacy29')}}</b><br />
    <p>{{$t('privacy30')}}</p>
    <p>{{$t('privacy31')}}</p>
    <br/>
    <b>{{$t('privacy32')}}</b><br />
    <p>{{$t('privacy33')}}</p>
    <p>{{$t('privacy34')}}</p>
    <p>{{$t('privacy35')}}</p>
    <p>{{$t('privacy36')}}</p>
    <p>{{$t('privacy37')}}</p>
    <br/>
    <b>{{$t('privacy38')}}</b><br />
    <p>{{$t('privacy39')}}</p>
    <br/>
    <b>{{$t('privacy40')}}</b><br />
    <p>{{$t('privacy41')}}</p>
    <br/>
    <b>{{$t('privacy42')}}</b><br />
    <p>{{$t('privacy43')}}</p>
    <p>{{$t('privacy44')}}</p>
    <p>{{$t('privacy45')}}</p>
    <br/>
    <b>{{$t('privacy46')}}</b><br />
    <b>{{$t('privacy47')}}</b><br />
    <p>{{$t('privacy48')}}</p>
    <p>{{$t('privacy49')}}</p>
    <p>{{$t('privacy50')}}</p>
    <b>{{$t('privacy51')}}</b><br />
    <p>{{$t('privacy52')}}</p>
    <b>{{$t('privacy53')}}</b><br />
    <p>{{$t('privacy54')}}</p>
    <p>{{$t('privacy55')}}</p>
    <ul>
      <li>{{$t('privacy56')}}</li>
      <li>{{$t('privacy57')}}</li>
      <li>{{$t('privacy58')}}</li>
      <li>{{$t('privacy59')}}</li>
    </ul>
    <p>{{$t('privacy60')}}</p>
    <b>{{$t('privacy61')}}</b><br />
    <p>{{$t('privacy62')}}</p>
    <p>{{$t('privacy63')}}</p>
    <p>{{$t('privacy64')}}</p>
    <p>{{$t('privacy65')}}</p>
    <p>{{$t('privacy66')}}</p>
  </div>
</template>

<script>

export default {
  components: { },
};
</script>

<style scoped>
.privacy-policy {
  text-align: left;
  padding: 1rem;
  padding-top: 40px;
}
</style>
